import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { CLessonInCourse, LESSON_STATUS } from '@yandex-int/k-common/typings/index';
import { CalendarIntervalDay } from 'platform-components';

export enum CalendarCardType {
    CLESSON = 'clesson',
}

type CalendarCardId = string;

export interface CourseCalendarColumnsCard {
    cardId: number;
    cardType: CalendarCardType;
}

export interface CourseCalendarColumns {
    cards: CourseCalendarColumnsCard[];
    maxVisibleCards: number;
    isAllCardsLoaded: boolean;
    columnLoadingStatus: LOADING_STATUSES;
}

export type CalendarClessons = Record<
    CalendarCardId,
    {
        courseId: number;
        clesson: CLessonInCourse;
    }
>;

export interface CourseCalendarEditor {
    intervalLoadingStatus: LOADING_STATUSES;
    currentInterval: CalendarIntervalDay[];
    columns: Record<string, CourseCalendarColumns>;
    clessons: CalendarClessons;
    markedMonthDaysLoadingStatus: LOADING_STATUSES;
    markedMonthDays: MarkedMonthDays;
}

export type CourseCalendarStore = Record<string, CourseCalendarEditor>;

export interface CourseCalendarMarkedClesson {
    date: number;
    status: LESSON_STATUS;
}

export interface CalendarCourse {
    courseId: number;
    start?: string;
    end?: string;
}

export type MarkedMonthDays = Record<string, Record<string, CourseCalendarMarkedClesson[]>>;
